import { yupResolver } from "@hookform/resolvers/yup";
import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";
import { AddressValidationStatus } from "@omni/types/api/customer/cloud/shared/enums/addressValidationStatus.enum";
import * as yup from "yup";

import { CustomerAddressFormBlock } from "@/components/Form/RHF/FormBlocks/Address/addressFormBlock.container";
import { CustomerDefaultAddressValidationSchema } from "@/components/Form/RHF/FormBlocks/Address/addressFormBlock.schema";
import { parseToBPostFieldAddress } from "@/components/Form/RHF/FormFields/BPostAddressField/helpers/address.helper";
import { HiddenField } from "@/components/Form/RHF/FormFields/HiddenField/hiddenField.component";
import { useOmniForm } from "@/components/Form/RHF/Utils/useOmniForm";
import { OmniFormContextProvider } from "@/utils/forms/omniForm.provider";

const EditDefaultAddressValidationSchema = yup
    .object({
        id: yup.string().required()
    })
    .concat(CustomerDefaultAddressValidationSchema);

type EditDefaultAddressFormValues = yup.InferType<
    typeof EditDefaultAddressValidationSchema
>;

type DefaultAddressFormProps = {
    address: CloudCustomerAddress;
    formId: string;
    skipValidation?: boolean;
    onFormSubmit: (
        data: CloudCustomerAddress,
        isBPostField: boolean
    ) => Promise<void>;
};

const EditDefaultAddressForm = ({
    address,
    formId,
    skipValidation = false,
    onFormSubmit
}: DefaultAddressFormProps) => {
    const methods = useOmniForm({
        mode: "onBlur",
        reValidateMode: "onBlur",
        defaultValues: {
            ...parseToBPostFieldAddress(address)
        },
        resolver: yupResolver(EditDefaultAddressValidationSchema)
    });

    const onSubmit = (data: EditDefaultAddressFormValues) => {
        const customerAddress = {
            ...address,
            ...data,
            box: data.box || "",
            addressing: ""
        } satisfies CloudCustomerAddress;

        onFormSubmit(customerAddress, !!data.selected);
    };

    return (
        <OmniFormContextProvider {...methods}>
            <form
                id={formId}
                onSubmit={methods.handleSubmit(onSubmit)}
            >
                <HiddenField<EditDefaultAddressFormValues> name="id" />
                <CustomerAddressFormBlock<
                    EditDefaultAddressFormValues,
                    AddressType.Default
                >
                    skipValidation={skipValidation}
                    addressType={AddressType.Default}
                    country={address.country}
                    addressStatus={
                        address.validationStatus ||
                        AddressValidationStatus.Unknown
                    }
                />
            </form>
        </OmniFormContextProvider>
    );
};

export { EditDefaultAddressForm };
